export const LOCALSTORAGE_KEYS = {
  authUser: 'user',
  state: 'persistantState',
  token: 'token',
  role: 'role',
  refreshToken: 'refresh_token'
};

export const routeArr = ['/stepper', '/verification', '/stepper/', '/verification/'];

export const ROLE_ADMIN: string[] = ['SUPER_ADMIN'];

export const dashboardProfileList = ['/', '/jobs'];

export const dateOptions: { [key: string]: string } = {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
};
